import React, { useState } from "react";
import Button from "../../components/Controls/Buttons/Button";
import AddIcon from "@mui/icons-material/Add";
import { Link } from "react-router-dom";

import {
  Box,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Tooltip,
} from "@mui/material";
import "./header.scss";
import jsPDF from "jspdf";
import "jspdf-autotable";
import AutorenewSharpIcon from "@mui/icons-material/AutorenewSharp";

const AdministratorHeader = (props) => {
  const {
    text,
    to,
    isShow,
    isExport,
    outPutButton,
    Click,
    showHistoryExport,
    selectedValueTOExport,
    handleRefresh,
    showRefreshBtn,
  } = props;

  const [selectedValue, setSelectedValue] = useState("");
  const exportPDF = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(100);

    const title = "Record History";
    const headers = [["Action", "Date & Time", "User Role", "User Name"]];
    const temp = isExport?.map((elt) => [
      elt.activity_name,
      elt.date,
      elt.user_group,
      elt.user_name,
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: temp,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("report.pdf");
  };
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    selectedValueTOExport(event.target.value);
  };

  return (
    <Box className="admin-box">
      <Typography className="administartor-project-title" variant="subtitle2">
        {text === "Upload Status" ? "Upload Pdf" : text}
      </Typography>
      {/* {text} */}
      {showRefreshBtn && (
        <Box style={{ paddingRight: "15px" }}>
          <Tooltip arrow title="Fetch New Folders">
            <IconButton onClick={handleRefresh} aria-label="delete">
              <AutorenewSharpIcon />
            </IconButton>
          </Tooltip>
          {/* <Buttons
                text="Refresh"
                variant="contained"
                onClick={handleRefresh}
                className="btn-continue"
              /> */}
        </Box>
      )}
      {isShow && (
        <Box
          style={{
            // paddingRight: "10px",
            marginLeft: "auto",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Link className="admin-header" to={to}>
            <Button
              text={text}
              size="small"
              sx={{width:"150px"}}
              variant="contained"
              startIcon={
                text === "Batch Records" || text === "Upload Status" ? (
                  ""
                ) : (
                  <AddIcon />
                )
              }
            ></Button>
          </Link>
        </Box>
      )}

      {isExport?.length > 0 && (
        <Button
          text="Export"
          className="export-btn"
          size="small"
          variant="contained"
          onClick={exportPDF}
        ></Button>
      )}

      {outPutButton?.length > 0 && (
        <Grid md={3}>
          <Button
            text={outPutButton}
            className="dp-detail-btn"
            size="small"
            variant="contained"
            onClick={Click}
            // disabled
          ></Button>
        </Grid>
      )}

      {showHistoryExport && (
        <Box className="export-div">
          <FormControl className="simple-select" fullWidth size="small">
            <InputLabel id="demo-simple-select-label">Export</InputLabel>

            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedValue}
              label="Export"
              onChange={handleChange}
            >
              <MenuItem value={"all"}>All</MenuItem>
              <MenuItem value={"selected"}>Selected</MenuItem>
            </Select>
          </FormControl>
        </Box>
      )}
    </Box>
  );
};

export default AdministratorHeader;
